import { useNavigate } from "react-router-dom";
import { Button } from "@jhool-io/fe-components";
import BackIcon from "../Icons/Back";
import { cn } from "../../utils/helpers";

interface BackLinkProps {
    /** Optional class for styling */
    buttonClass?: string;
    /** Route to naviagate back to */
    to?: string;
    /** Optional style prop to add inline styles */
    style?: Record<string, string>;
    /** function to run if button is not a link */
    onClick?: () => void;
    /** Text to display instead of "Back" */
    backText?: string;
    /** Optional button title  */
    title?: string;
}

export default function BackLink({
    to,
    buttonClass,
    style,
    onClick,
    backText,
    title,
}: BackLinkProps) {
    const navigate = useNavigate();

    const handleButtonClick = () => {
        return to ? navigate(to) : onClick?.();
    };

    return (
        <Button
            onClick={handleButtonClick}
            variant="normal"
            className={cn(
                "flex items-center gap-x-8 text-sm text-gray px-0",
                buttonClass
            )}
            type="button"
            size="auto"
            style={style}
            title={title}
        >
            <BackIcon /> {backText || "Back"}
        </Button>
    );
}
